export enum StreamCommandEnum {
    on = 1,
    off = 2,
}
